import { DecimalPipe } from '@angular/common'
import { Component, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ContextService } from '../../services'

@Component({
  standalone: false,
  selector: 'app-bars-widget',
  templateUrl: './bars-widget.component.html',
  styleUrls: ['./bars-widget.component.scss'],
})
export class BarsWidgetComponent {
  @Input() title = ''
  @Input() unit = ''
  @Input() highlight: string[] = []
  @Input() showTooltip: true
  @Input() isMultiple = false
  @Input() stats
  @Input() formatNumber = '1.0-0'
  @Input() showZeros = false
  private _isCompact = false
  @Input() get isCompact() {
    return this._isCompact && this.isMultiple
  }

  set isCompact(c) {
    this._isCompact = c
  }

  @Input()
  get data() {
    return this._data
  }

  set data(value: any[]) {
    this._data = value
    let maxData = 0
    let maxCompare = 0
    this.maxValueCompareMode = 0
    if (this.comparisonData) {
      ;(this.comparisonData || []).forEach((_, i) => {
        this.rawDifferences[i] = this.getRawDifference(i)
        this.differences[i] = this.getDifference(i)
        maxCompare = _.value > maxCompare ? _.value : maxCompare
      })
      ;(this.referenceData || []).forEach((_, i) => {
        this.rawDifferences[i] = this.getRawDifference(i)
        this.differences[i] = this.getDifference(i)
        maxData = _.value > maxData ? _.value : maxData
      })
    } else {
      ;(this.referenceData || []).forEach((_, i) => {
        maxData = _.value > maxData ? _.value : maxData
      })
    }
    this.maxValueCompareMode = Math.max(maxData, maxCompare)
  }

  _data = []
  differences = []
  rawDifferences: number[] = []
  maxValueCompareMode = 0

  get referenceData() {
    return this.isMultiple
      ? !Array.isArray(this.data[0])
        ? [this.data[0]]
        : this.data[0]
      : this.data
  }

  get comparisonData() {
    return this.isMultiple && this.data[1]
      ? !Array.isArray(this.data[1])
        ? [this.data[1]]
        : this.data[1]
      : null
  }

  get keyIndicatorLabel() {
    return this.context.keyIndicator.label.toLowerCase()
  }

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  constructor(
    private decimal: DecimalPipe,
    private translate: TranslateService,
    private context: ContextService,
  ) {}

  isNumber(value) {
    return !isNaN(Number(value))
  }

  formatPerc(value, format = '1.1-2') {
    if (value === '--') {
      return value
    }

    if (this.showZeros || value !== 0) {
      if (value === 0) {
        return '0'
      }

      return this.decimal.transform(value, format)
    }

    return 'NA'
  }

  getPercentageTotalValue(val) {
    return (val / this.stats) * 100
  }

  private getRawDifference(index) {
    const ref = this.referenceData[index] || { value: 0 }
    const compare = this.comparisonData[index] || { value: 0 }

    return ref.value - compare.value
  }

  private getDifference(index) {
    const raw = this.rawDifferences[index]

    return raw === 0
      ? this.translate.instant('Same')
      : this.decimal.transform(raw, '1.0-0')
  }
}
